import {AccordionDetails, styled} from '@mui/material';

export const CustomAccordionDetails = styled(AccordionDetails)`
	&.MuiAccordionDetails-root {
		margin-bottom: -${({theme}) => theme.spacing(2)};
		padding: 0;
	}
`;
